// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InferNameMatchQueryVariables = Types.Exact<{
  input: Types.InferNameMatchInput;
}>;


export type InferNameMatchQuery = { __typename?: 'Query', inferNameMatch?: string | null };

export type InferInsurancePolicyKindQueryVariables = Types.Exact<{
  input: Types.Scalars['String']['input'];
}>;


export type InferInsurancePolicyKindQuery = { __typename?: 'Query', inferInsurancePolicyKind?: Types.InsurancePolicyKind | null };

export const Operations = {
  Query: {
    InferNameMatch: 'InferNameMatch' as const,
    InferInsurancePolicyKind: 'InferInsurancePolicyKind' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const InferNameMatchDocument = gql`
    query InferNameMatch($input: InferNameMatchInput!) {
  inferNameMatch(input: $input)
}
    `;

/**
 * __useInferNameMatchQuery__
 *
 * To run a query within a React component, call `useInferNameMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useInferNameMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInferNameMatchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInferNameMatchQuery(baseOptions: Apollo.QueryHookOptions<InferNameMatchQuery, InferNameMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InferNameMatchQuery, InferNameMatchQueryVariables>(InferNameMatchDocument, withFetchPolicyContext(options));
      }
export function useInferNameMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InferNameMatchQuery, InferNameMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InferNameMatchQuery, InferNameMatchQueryVariables>(InferNameMatchDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useInferNameMatchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InferNameMatchQuery, InferNameMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InferNameMatchQuery, InferNameMatchQueryVariables>(InferNameMatchDocument, withFetchPolicyContext(options));
        }
export type InferNameMatchQueryHookResult = ReturnType<typeof useInferNameMatchQuery>;
export type InferNameMatchLazyQueryHookResult = ReturnType<typeof useInferNameMatchLazyQuery>;
export type InferNameMatchSuspenseQueryHookResult = ReturnType<typeof useInferNameMatchSuspenseQuery>;
export type InferNameMatchQueryResult = Apollo.QueryResult<InferNameMatchQuery, InferNameMatchQueryVariables>;
export const InferInsurancePolicyKindDocument = gql`
    query InferInsurancePolicyKind($input: String!) {
  inferInsurancePolicyKind(input: $input)
}
    `;

/**
 * __useInferInsurancePolicyKindQuery__
 *
 * To run a query within a React component, call `useInferInsurancePolicyKindQuery` and pass it any options that fit your needs.
 * When your component renders, `useInferInsurancePolicyKindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInferInsurancePolicyKindQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInferInsurancePolicyKindQuery(baseOptions: Apollo.QueryHookOptions<InferInsurancePolicyKindQuery, InferInsurancePolicyKindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InferInsurancePolicyKindQuery, InferInsurancePolicyKindQueryVariables>(InferInsurancePolicyKindDocument, withFetchPolicyContext(options));
      }
export function useInferInsurancePolicyKindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InferInsurancePolicyKindQuery, InferInsurancePolicyKindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InferInsurancePolicyKindQuery, InferInsurancePolicyKindQueryVariables>(InferInsurancePolicyKindDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useInferInsurancePolicyKindSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InferInsurancePolicyKindQuery, InferInsurancePolicyKindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InferInsurancePolicyKindQuery, InferInsurancePolicyKindQueryVariables>(InferInsurancePolicyKindDocument, withFetchPolicyContext(options));
        }
export type InferInsurancePolicyKindQueryHookResult = ReturnType<typeof useInferInsurancePolicyKindQuery>;
export type InferInsurancePolicyKindLazyQueryHookResult = ReturnType<typeof useInferInsurancePolicyKindLazyQuery>;
export type InferInsurancePolicyKindSuspenseQueryHookResult = ReturnType<typeof useInferInsurancePolicyKindSuspenseQuery>;
export type InferInsurancePolicyKindQueryResult = Apollo.QueryResult<InferInsurancePolicyKindQuery, InferInsurancePolicyKindQueryVariables>;